module.exports = __webpack_public_path__ + "media/images/castlerock/faq-0053e92b204b97ca4f6fc789c9c9f00f.jpg";